import React, { useEffect } from 'react';
import './styles.scss';
import useGetStartedActionsContext from 'contexts/get-started-actions.context';
import { Input } from '@cokitchen/cokitchen-components';

export type DepartmentType = 'name';
export type DepartmentFormType = {
  name: string;
};

const AddDepartment = () => {
  const EMPTY_FORM = {
    name: ''
  };

  const { departmentFormData, setDepartmentFormData, setIsDisabled } =
    useGetStartedActionsContext();

  useEffect(() => {
    setIsDisabled(!departmentFormData[0]?.name?.length);
  }, [departmentFormData]);

  const handleDelete = (i: number) => {
    const filteredDepartment = departmentFormData.filter((department, index) => index !== i);
    setDepartmentFormData([...filteredDepartment]);
  };

  const handleChange = (e: any, i: number, field: DepartmentType) => {
    const { target } = e;
    const { value } = target;
    departmentFormData[i][field] = value;
    setDepartmentFormData([...departmentFormData]);
  };

  const handleAddDep = () => {
    setDepartmentFormData([...departmentFormData, EMPTY_FORM]);
  };

  return (
    <div className='add-dept max-w-[390px] w-full px-4'>
      <div>
        <h2 className='text-[28px] xs:text-[32px] font-bold'>Add Department</h2>
        <p className='text-[14px] xs:text-[16px] text-[#6F7376]'>
          Create your employee departments
        </p>
      </div>
      {departmentFormData?.length !== 0 &&
        departmentFormData?.map(({ name }, i) => (
          <div key={i} className='flex w-full gap-[70px] pt-[42px] text-[14px]'>
            <div className='w-full relative'>
              <Input
                design='bordered'
                type='text'
                label='Department name'
                name='name'
                placeholder='e.g Accounting'
                onChange={(e) => handleChange(e, i, 'name')}
                value={name}
              />
              {i !== 0 && (
                <button
                  onClick={() => handleDelete?.(i)}
                  className='text-red-5 cursor-pointer absolute right-0 top-0'>
                  - Remove
                </button>
              )}
            </div>
          </div>
        ))}

      <div onClick={handleAddDep} className='cursor-pointer pt-4 mt-4'>
        <p className=' text-[#0080E5]'>+ Add department</p>
      </div>
    </div>
  );
};

export default AddDepartment;
